module.exports = __webpack_public_path__ + "img/toggle-select2.1e86c338.png";